import useActions from '../../../hooks/useActions';
import { putSubtotalActions } from '../../../redux/actions/putSubtotalActions';
import { makeDeliveryMethodsForCart } from '../../../redux/selectors/checkoutPageSelectors';
import { makeFreeDeliveryThreshold } from '../../../redux/selectors/freeDeliverySelector';
import { getCurrentSubmitBillDataByName } from '../../../redux/selectors/transactionDetail';
import {
  makeDefaultCurrencyData,
  makeDefaultShippingFeesData,
} from '../../../redux/selectors/VBConfigSelector';
import { useSelector } from '../../../redux/utils';
import { getIsTW } from '../../../utils/countryInfo';

export const useData = () => {
  const methods = useSelector(makeDeliveryMethodsForCart());
  const currency = useSelector(makeDefaultCurrencyData());
  const shippingFees = useSelector(makeDefaultShippingFeesData());
  const putSubtotal = useActions(putSubtotalActions.request);
  const currentMethod = useSelector(
    getCurrentSubmitBillDataByName('delivery_mode')
  );
  const freeDeliveryDiff = useSelector(makeFreeDeliveryThreshold());
  const isFreeDelivery = getIsTW() && freeDeliveryDiff <= 0;

  return {
    currentMethod,
    methods,
    currency,
    shippingFees,
    putSubtotal,
    isFreeDelivery,
  };
};
